import { Logger } from 'shared-components/utils';

const logger = new Logger('safeLocalStorage');

const getLocalStorage = (): Storage | null => {
  try {
    if (typeof window === 'undefined') {
      return null;
    }
    return window.localStorage;
  } catch (error) {
    logger.error('localStorage access failed', error);
    return null;
  }
};

export const safeLocalStorageGetItem = (key: string): string | null => {
  try {
    return getLocalStorage()?.getItem(key) ?? null;
  } catch (error) {
    logger.error('localStorage getItem failed', error);
    return null;
  }
};

export const safeLocalStorageSetItem = (key: string, value: string): void => {
  try {
    getLocalStorage()?.setItem(key, value);
  } catch (error) {
    logger.error('localStorage setItem failed', error);
  }
};

export const safeLocalStorageRemoveItem = (key: string): void => {
  try {
    getLocalStorage()?.removeItem(key);
  } catch (error) {
    logger.error('localStorage removeItem failed', error);
  }
};
